<script lang="ts" setup>
import { useAppBrand } from '@shared/lib/app-brand'

import { useBannerUpsell } from './banner-upsell.hook'
import BannerUpsellCobweb from './BannerUpsellCobweb.vue'
import BannerUpsellCountdown from './BannerUpsellCountdown.vue'
import BannerUpsellTitle from './BannerUpsellTitle.vue'
import BannerUpsellOffer from './BannerUpsellOffer.vue'

defineOptions({
  name: 'BannerUpsell',
})

const { isSmartestMinds } = useAppBrand()

const {
  title,
  titleMobile,
  isVisible,
  offer,
  ctaLabel,
  href,
  countdownText,
  setSubmit,
} = useBannerUpsell()
</script>

<template>
  <div
    v-if="isVisible"
    :class="['banner-upsell', { 'banner-upsell--smartestminds': isSmartestMinds }]"
  >
    <BannerUpsellCobweb class="banner-upsell__cobweb" />
    <div class="banner-upsell__content">
      <div class="banner-upsell__head">
        <div class="banner-upsell__promo">
          <BannerUpsellTitle
            :title="title"
            :title-mobile="titleMobile"
          />
        </div>
        <BannerUpsellCountdown
          :text="countdownText"
          class="banner-upsell__countdown"
        />
      </div>
      <BannerUpsellOffer
        :offer="offer"
        :cta-label="ctaLabel"
        :href="href ?? ''"
        @click:cta="setSubmit"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./BannerUpsell.scss" />
